


































import Vue from 'vue'
import Component from 'vue-class-component'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'

@Component({
  components: {
    ModalV2,
    Checkbox
  }
})
export default class ElectronicRecordConfirm extends Vue {
  isAgree: boolean = false
}
